const fonts = {
  knowledge: {
    black: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: normal; font-weight: 900;',
    blackItalic: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: italic; font-weight: 900;',
    bold: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: normal; font-weight: 700;',
    boldItalic: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: italic; font-weight: 700;',
    light: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: normal; font-weight: 300;',
    lightItalic: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: italic; font-weight: 300;',
    medium: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: normal; font-weight: 500;',
    mediumItalic: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: italic; font-weight: 500;',
    regular: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: normal; font-weight: 400;',
    regularItalic: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: italic; font-weight: 400;',
    ultraLight: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: normal; font-weight: 100;',
    ultraLightItalic: 'Knowledge2017, arial, helvetica, clean, sans-serif; font-style: italic; font-weight: 100;'
  }
}

export const fontSizes = {
  'tn': { size: '11px', lineHeight: '1.82' },
  'sm': { size: '13px', lineHeight: '1.54' },
  'md': { size: '15px', lineHeight: '1.6' },
  'lg': { size: '18px', lineHeight: '1.94' }
}

export default fonts
